/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Task_Management_AreaInputs */

const en_home_task_management_area = /** @type {(inputs: Home_Task_Management_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Management`)
};

const lv_home_task_management_area = /** @type {(inputs: Home_Task_Management_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vadība`)
};

/**
* | output |
* | --- |
* | "Management" |
*
* @param {Home_Task_Management_AreaInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_task_management_area = /** @type {((inputs?: Home_Task_Management_AreaInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Task_Management_AreaInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_task_management_area(inputs)
	return en_home_task_management_area(inputs)
});